import type { DateTime } from 'luxon'
import { formatDTMilitaryWDate } from '~/utils'

/**
 * How an export empty-pickup window reads to a user.
 *
 * A missing end is not missing data: these are pre-advice appointments, valid
 * for the whole day rather than for an hour (the terminal decides that, not the
 * user). Saying so beats rendering a bare start time, which reads as a deadline
 * the driver has to hit.
 *
 * Shared by the confirm dialog (formatting the slot about to be booked) and the
 * booking drawer (formatting the appointment that came back), so the two cannot
 * describe the same window differently.
 */
/**
 * How a day-level (pre-advice) window is named, wherever one is shown. Used
 * verbatim by both surfaces so the slot the user picks and the appointment they
 * get back are labelled identically.
 */
export const PRE_ADVICE_WINDOW_DESCRIPTION = 'All day'

export function exportPickupWindowDescription(
  windowStart: DateTime,
  windowEnd?: DateTime | null
): string {
  if (!windowEnd) {
    return `${windowStart.toFormat('ccc M/d')} — ${PRE_ADVICE_WINDOW_DESCRIPTION}`
  }
  return `${formatDTMilitaryWDate(windowStart)}–${windowEnd.toFormat('HH:mm')}`
}
